import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import VuexORM from '@vuex-orm/core';
import { i18n } from "../../boot/i18n";
var Price = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Price, _VuexORM$Model);
  var _super = _createSuper(Price);
  function Price() {
    _classCallCheck(this, Price);
    return _super.apply(this, arguments);
  }
  _createClass(Price, [{
    key: "formattedPrice",
    get: function get() {
      return i18n.t('app.subscriptions.currency_symbol.' + this.currency) + this.amount + '/' + i18n.t('app.subscriptions.interval.' + this.interval);
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'prices';
    }

    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        product: this.attr(null),
        active: this.boolean(null),
        livemode: this.boolean(null),
        currency: this.attr(null),
        type: this.attr(null),
        interval: this.attr(null),
        interval_count: this.number(null),
        unit_amount: this.number(null),
        nickname: this.attr(null),
        slug: this.attr(null),
        trial_period_days: this.attr(null),
        created: this.attr(null),
        amount: this.attr(null)
      };
    }
  }]);
  return Price;
}(VuexORM.Model);
export { Price as default };